import React from 'react';

export interface Props {
  wellName?: string;
  isScreenRoute?: boolean;
  dropVol?: any;
  wellInfoHTML?: any;
  wellVolume?: any;
  wellWaterVolume?: any;
  layerName?: string;
}
function IngredientWellInfo(props: Props) {
  const { wellName, wellInfoHTML, wellVolume, wellWaterVolume } = props;
  return (
    <div id="ingredientwellinfo-main-container" style={{ margin: '0px 10px' }}>
      <div
        id="ingredientwellinfo-content-wrapper"
        className="row blackColor "
        style={{ alignItems: 'baseline' }}
      >
        <span id="ingredientwellinfo-content-wellname" className="ingHeading">
          {wellName}
        </span>
        <span id="ingredientwellinfo-content-volumes" style={{ margin: '5px 0px' }}>
          Well Volume: {wellVolume}uL / Water Volume: {wellWaterVolume}uL{' '}
        </span>
      </div>

      <div id="ingredientwellinfo-sub-container" className="wellInfoContainer">
        {wellInfoHTML}
      </div>
    </div>
  );
}

export default IngredientWellInfo;
